import { Button, ButtonProps, Box } from "@mui/material";
import { FC } from "react";

interface ClickableDisabledButtonProps extends Omit<ButtonProps, "onClick"> {
  onClick: () => void;
  onDisabledClick?: () => void;
  disabled?: boolean;
}

/**
 * A button component that can handle clicks even when disabled.
 * When disabled and clicked, it calls onDisabledClick instead of onClick.
 */
const ClickableDisabledButton: FC<ClickableDisabledButtonProps> = ({
  onClick,
  onDisabledClick,
  disabled = false,
  children,
  ...buttonProps
}) => {
  if (!disabled) {
    // Normal button behavior when not disabled
    return (
      <Button onClick={onClick} disabled={false} {...buttonProps}>
        {children}
      </Button>
    );
  }

  // When disabled, we need to handle clicks on a wrapper
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-block",
      }}
    >
      {/* The actual disabled button */}
      <Button disabled={true} {...buttonProps}>
        {children}
      </Button>

      {/* Invisible overlay that captures clicks when disabled */}
      {onDisabledClick && (
        <Box
          onClick={onDisabledClick}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            cursor: "not-allowed",
            zIndex: 1,
          }}
        />
      )}
    </Box>
  );
};

export default ClickableDisabledButton;
